import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['segment', 'hidden'];
  static values = { groupSize: { type: Number, default: 4 } };

  handleInput(event) {
    const segment = event.target;
    segment.value = segment.value.toUpperCase().replace(/[^0-9A-Z]/g, '');

    this.syncHidden();

    if (segment.value.length >= this.groupSizeValue) {
      segment.value = segment.value.slice(0, this.groupSizeValue);
      const nextIndex = parseInt(segment.dataset.segmentIndex, 10) + 1;
      const next = this.segmentTargets[nextIndex];
      if (next) next.focus();
    }
  }

  handleKeydown(event) {
    if (event.key !== 'Backspace') return;

    const segment = event.target;
    if (segment.selectionStart === 0 && segment.selectionEnd === 0) {
      const prevIndex = parseInt(segment.dataset.segmentIndex, 10) - 1;
      const prev = this.segmentTargets[prevIndex];
      if (prev) {
        event.preventDefault();
        prev.focus();
        prev.setSelectionRange(prev.value.length, prev.value.length);
      }
    }
  }

  handlePaste(event) {
    event.preventDefault();
    const pasted = (event.clipboardData || window.clipboardData)
      .getData('text')
      .toUpperCase()
      .replace(/[^0-9A-Z]/g, '');

    const size = this.groupSizeValue;
    this.segmentTargets.forEach((segment, index) => {
      segment.value = pasted.slice(index * size, (index + 1) * size);
    });

    this.syncHidden();

    const lastFilled = this.segmentTargets.findLast((s) => s.value.length > 0);
    if (lastFilled) lastFilled.focus();
  }

  syncBeforeSubmit() {
    this.syncHidden();
  }

  syncHidden() {
    this.hiddenTarget.value = this.segmentTargets.map((s) => s.value).join('');
  }
}
